import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Services/ServicesBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Services/ServicesFaq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Services/ServicesFeesTable.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Services/ServicesRealCards.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Services/ServicesRelatedProducts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Services/ServicesSteps.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Shared/common/Calculator.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/utils/Markdown.css");
